/** Minimal Web Speech API recogniser (Chrome/Edge/Safari). `available` is false elsewhere; the mic button is then hidden. */
interface Recog {
  lang: string;
  interimResults: boolean;
  maxAlternatives: number;
  onresult: ((e: { results: ArrayLike<ArrayLike<{ transcript: string }> & { isFinal: boolean }> }) => void) | null;
  onend: (() => void) | null;
  onerror: ((e: { error: string }) => void) | null;
  start(): void;
  stop(): void;
}

type RecogCtor = new () => Recog;

export class SpeechInput {
  private recog: Recog | undefined;
  private readonly Ctor: RecogCtor | undefined;
  constructor(w: Record<string, unknown> = globalThis as unknown as Record<string, unknown>) {
    this.Ctor = (w.SpeechRecognition ?? w.webkitSpeechRecognition) as RecogCtor | undefined;
  }
  get available(): boolean {
    return !!this.Ctor;
  }
  get listening(): boolean {
    return !!this.recog;
  }
  /** Listen once. `onPartial` gets interim text; resolves with the final transcript ("" if nothing heard). */
  listen(onPartial: (t: string) => void): Promise<string> {
    if (!this.Ctor) return Promise.resolve("");
    this.stop();
    const r = (this.recog = new this.Ctor());
    r.lang = "en-GB";
    r.interimResults = true;
    r.maxAlternatives = 1;
    let text = "";
    return new Promise((resolve) => {
      r.onresult = (e) => {
        text = Array.from(e.results).map((x) => x[0]?.transcript ?? "").join("");
        onPartial(text);
      };
      r.onerror = () => undefined;
      r.onend = () => {
        this.recog = undefined;
        resolve(text.trim());
      };
      r.start();
    });
  }
  stop(): void {
    this.recog?.stop();
  }
}
